import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import PublicNavHeader from '../components/PublicNavHeader';
import Footer from '../components/Footer';

import {
  CheckCircle,
  Circle,
  Clock,
  MapTrifold
} from '@phosphor-icons/react';
const Roadmap = () => {
  const roadmapItems = [
    { status: 'done', title: 'Voice Agent Builder', description: 'Build and deploy voice agents with custom workflows.', quarter: 'Q4 2024' },
    { status: 'done', title: 'Agent Marketplace', description: 'Browse and deploy pre-built agent templates.', quarter: 'Q4 2024' },
    { status: 'done', title: 'Partner Program', description: 'Join our curated network of AI professionals.', quarter: 'Q1 2025' },
    { status: 'current', title: 'Multi-Agent Workflows', description: 'Chain multiple agents together for complex automations.', quarter: 'Q1 2025' },
    { status: 'upcoming', title: 'Enterprise SSO', description: 'SAML/OIDC authentication for enterprise teams.', quarter: 'Q2 2025' },
    { status: 'upcoming', title: 'API Marketplace', description: 'Connect agents to third-party services.', quarter: 'Q2 2025' }
  ];

  const getStatusIcon = (status) => {
    switch (status) {
      case 'done': return <CheckCircle size={20} className="text-[#14F195]" />;
      case 'current': return <Clock size={20} className="text-[#6366F1]" />;
      default: return <Circle size={20} className="text-[#718096]" />;
    }
  };

  return (
    <>
      <SEO title="Roadmap - Man & Machine" description="See what we're building next at Man & Machine." />
      <PublicNavHeader />
      
      <div className="min-h-screen bg-[#0a0a0f]">
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[#6366F1]/10 via-transparent to-[#EC4899]/10" />
          
          <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-28">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center max-w-3xl mx-auto"
            >
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#6366F1]/10 border border-[#6366F1]/20 text-[#6366F1] text-sm font-medium mb-6">
                <MapTrifold size={16} />
                Product Roadmap
              </div>
              <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                What We're Building
              </h1>
              <p className="text-lg text-[#A0AEC0]">
                Our commitment to building the best Business AI OS.
              </p>
            </motion.div>
          </div>
        </section>

        <section className="max-w-3xl mx-auto px-6 pb-20">
          <div className="space-y-4">
            {roadmapItems.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.1 }}
                className={`glass rounded-xl p-5 flex items-start gap-4 ${
                  item.status === 'current' ? 'border-[#6366F1]/30' : ''
                }`}
              >
                <div className="mt-1">{getStatusIcon(item.status)}</div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-1">
                    <h3 className="font-semibold text-white">{item.title}</h3>
                    <span className="text-xs px-2 py-0.5 rounded bg-[rgba(255,255,255,0.05)] text-[#A0AEC0]">{item.quarter}</span>
                  </div>
                  <p className="text-[#A0AEC0] text-sm">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default Roadmap;